import React, {useReducer} from 'react';
import {SnackBarContext} from './context';
import reducer from './reducer';
import {
  SnackBarContextActionType,
  SnackBarContextState,
  SetPublicToastNotification,
  SetOfficeToastNotification,
  SetDailyCareLogToastNotification,
} from './types';

// Set Initial State
const initialState: SnackBarContextState = {
  publicToastNotification: {
    open: false,
    autoHideDuration: 6000,
  },
  officeToastNotification: {
    open: false,
    autoHideDuration: 6000,
  },
  dailyCareLogToastNotification: {
    open: false,
    autoHideDuration: 6000,
  },
};

export const SnackBarContextProvider = (props: {children: React.ReactNode}) => {
  // Create Reducer
  const [state, dispatch] = useReducer(reducer, initialState);

  const setPublicToastNotification = async (
    notification: SetPublicToastNotification
  ): Promise<any> => {
    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.SET_PUBLIC_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.publicToastNotification,
        open: true,
        severity: notification.severity,
        message: notification.message,
        title: notification.title,
      },
    });
  };

  const resetPublicToastNotification = async (
    event?: React.SyntheticEvent,
    reason?: string
  ): Promise<any> => {
    // Evaluate reason
    if (reason === 'clickaway') {
      return;
    }

    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.RESET_PUBLIC_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.publicToastNotification,
        open: false,
        // Do not reset this because of the animation we use.
        //title: undefined,
        //message: undefined,
        //severity: undefined,
      },
    });
  };

  const setOfficeToastNotification = async (
    notification: SetOfficeToastNotification
  ): Promise<any> => {
    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.SET_OFFICE_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.officeToastNotification,
        open: true,
        severity: notification.severity,
        message: notification.message,
        title: notification.title,
      },
    });
  };

  const resetOfficeToastNotification = async (
    _event?: React.SyntheticEvent,
    reason?: string
  ): Promise<any> => {
    // Evaluate reason
    if (reason === 'clickaway') {
      return;
    }

    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.RESET_OFFICE_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.officeToastNotification,
        open: false,
        // Do not reset this because of the animation we use.
        //title: undefined,
        //message: undefined,
        //severity: undefined,
        //buttonLabel: undefined,
      },
    });
  };

  const setDailyCareLogToastNotification = async (
    notification: SetDailyCareLogToastNotification
  ): Promise<any> => {
    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.SET_DAILY_CARE_LOG_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.dailyCareLogToastNotification,
        open: true,
        severity: notification.severity,
        message: notification.message,
        title: notification.title,
      },
    });
  };

  const resetDailyCareLogToastNotification = async (
    _event?: React.SyntheticEvent,
    reason?: string
  ): Promise<any> => {
    // Evaluate reason
    if (reason === 'clickaway') {
      return;
    }

    // Dispatch change
    dispatch({
      type: SnackBarContextActionType.RESET_DAILY_CARE_LOG_TOAST_NOTIFICATION,
      toastNotification: {
        ...state.dailyCareLogToastNotification,
        open: false,
      },
    });
  };

  return (
    <SnackBarContext.Provider
      value={{
        state,
        // Methods
        setPublicToastNotification,
        resetPublicToastNotification,
        setOfficeToastNotification,
        resetOfficeToastNotification,
        setDailyCareLogToastNotification,
        resetDailyCareLogToastNotification,
      }}
    >
      {props.children}
    </SnackBarContext.Provider>
  );
};
